(() => {
  if (window.__amaLegacyQuantityBridge20260917) return;
  window.__amaLegacyQuantityBridge20260917 = true;

  const pendingSections = new WeakMap();

  const getStatus = (button) => {
    let status = button.parentElement?.querySelector('[data-ama-legacy-status]');
    if (!status) {
      status = document.createElement('span');
      status.className = 'visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.dataset.amaLegacyStatus = '';
      button.insertAdjacentElement('afterend', status);
    }
    return status;
  };

  const findProductForm = (section) => {
    const productInfo = section.closest('product-info');
    return (
      productInfo?.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  };

  const watchResult = ({ section, productForm, variantId, button, originalHtml, status }) => {
    let done = false;
    const cleanups = [];

    const cleanup = () => {
      cleanups.forEach((unsubscribe) => {
        if (typeof unsubscribe === 'function') unsubscribe();
      });
      productForm?.removeEventListener('shopify:cart:error', onStandardError);
      pendingSections.delete(section);
    };

    const finish = (ok) => {
      if (done) return;
      done = true;
      cleanup();
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.innerHTML = originalHtml;
      status.textContent = ok ? 'Ajouté au panier.' : 'Impossible d’ajouter au panier. Réessayez.';
    };

    const matchesVariant = (event) => String(event?.productVariantId ?? '') === String(variantId);

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      finish(false);
      return false;
    }

    cleanups.push(subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source !== 'product-form' || !matchesVariant(event)) return;
      finish(true);
    }));

    cleanups.push(subscribe(PUB_SUB_EVENTS.cartError, (event) => {
      if (event?.source !== 'product-form' || !matchesVariant(event)) return;
      finish(false);
    }));

    function onStandardError() {
      finish(false);
    }

    productForm?.addEventListener('shopify:cart:error', onStandardError);
    pendingSections.set(section, cleanup);
    return true;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.bundle-section .js-btn-add, .bundle-section .js-bsafe-native-add');
    if (!button) return;

    const section = button.closest('.bundle-section');
    if (!section || section.dataset.bundleDisabled === 'true') return;

    event.preventDefault();
    event.stopPropagation();

    if (pendingSections.has(section) || button.disabled) return;

    const card = button.closest('.js-select-bundle, .bundle-card');
    if (card) {
      section.querySelectorAll('.js-select-bundle').forEach((item) => item.classList.remove('selected'));
      card.classList.add('selected');
    }

    const form = findProductForm(section);
    const productForm = form?.closest('product-form');
    const status = getStatus(button);

    if (!form || !productForm) {
      status.textContent = 'Ajout au panier momentanément indisponible.';
      return;
    }

    const idInput = form.querySelector('input[name="id"]');
    let quantityInput = form.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      form.appendChild(quantityInput);
    }

    const isBsafeButton = button.classList.contains('js-bsafe-native-add');
    if (!isBsafeButton && card?.dataset.vid && idInput) idInput.value = card.dataset.vid;
    quantityInput.value = isBsafeButton ? '1' : (card?.dataset.qty || '1');

    const variantId = idInput?.value;
    if (!variantId) {
      status.textContent = 'Option produit indisponible.';
      return;
    }

    const nativeButton =
      form.querySelector('.product-form__submit') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('button[name="add"]');

    if (nativeButton && (nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true')) {
      status.textContent = 'Cette option est momentanément indisponible.';
      return;
    }

    const originalHtml = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Ajout en cours…';
    status.textContent = '';

    const watching = watchResult({ section, productForm, variantId, button, originalHtml, status });
    if (!watching) return;

    try {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    } catch (error) {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }, true);
})();
